module.exports = __webpack_public_path__ + "img/robot.e1df3e5b.svg";